import dayjs from 'dayjs';

const formatDate = (date: string, format: string) => dayjs(date).format(format);

export default formatDate;
